import { Fields, Loading } from "../workspace/Controls";
import { useContentRecords } from "./ContentLibrary";
export default function ServiceCatalogueFields({ schema, value, setValue }) {
  const services = useContentRecords("services", 0);
  const entries = value.entries || [];
  function change(index, entry) {
    setValue({
      ...value,
      entries: entries.map((current, i) => (i === index ? entry : current)),
    });
  }
  return (
    <>
      <Fields
        schema={{
          ...schema,
          properties: Object.fromEntries(
            Object.entries(schema.properties).filter(
              ([key]) => key !== "entries",
            ),
          ),
        }}
        value={value}
        onChange={setValue}
      />
      <Loading state={services}>
        {entries.map((entry, index) => {
          const item = schema.properties.entries.items;
          return (
            <fieldset className="aw-array" key={index}>
              <legend>Catalogue entry {index + 1}</legend>
              <Fields
                schema={{
                  ...item,
                  properties: Object.fromEntries(
                    Object.entries(item.properties).filter(
                      ([key]) =>
                        (key !== "servicesDisplay" || entry.kind === "service") && key !==
                        (entry.kind === "service" ? "path" : "serviceId"),
                    ),
                  ),
                }}
                prefix={`catalogue-${index}`}
                value={entry}
                choices={{
                  serviceId: services.data.map((service) => ({
                    id: service.id,
                    name: `${service.title} · ${service.status}`,
                  })),
                }}
                onChange={(next) => {
                  const cleaned = { ...next };
                  delete cleaned[
                    next.kind === "service" ? "path" : "serviceId"
                  ];
                  if (next.kind !== "service") delete cleaned.servicesDisplay;
                  change(index, cleaned);
                }}
              />
              <div className="aw-row">
                {[-1, 1].map((step) => (
                  <button
                    type="button"
                    className="aw-button aw-small"
                    key={step}
                    disabled={
                      index + step < 0 || index + step >= entries.length
                    }
                    onClick={() => {
                      const next = [...entries];
                      [next[index], next[index + step]] = [
                        next[index + step],
                        next[index],
                      ];
                      setValue({ ...value, entries: next });
                    }}
                  >
                    {step < 0 ? "Move up" : "Move down"}
                  </button>
                ))}
                <button
                  type="button"
                  className="aw-button aw-small"
                  onClick={() =>
                    setValue({
                      ...value,
                      entries: entries.filter((_, i) => i !== index),
                    })
                  }
                >
                  Remove entry
                </button>
              </div>
            </fieldset>
          );
        })}
      </Loading>
      <button
        type="button"
        className="aw-button"
        disabled={entries.length >= 30}
        onClick={() =>
          setValue({
            ...value,
            entries: [
              ...entries,
              {
                id: crypto.randomUUID(),
                kind: "service",
                icon: "Truck",
                homepageVisible: false,
                servicesVisible: true,
              },
            ],
          })
        }
      >
        Add catalogue entry
      </button>
    </>
  );
}
